<template>
  <div id="carRentalContract"  v-loading="loading">
    <div class="buttons"  v-loading="loading">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="PrintContractD"
        style="margin: 10px 0"
        >打印 </el-button
      ><el-button
        type="primary"
        icon="el-icon-plus"
        @click="saveContractA"
        style="margin: 10px 10px"
        v-if="dialogForm.approveStatus != 3 && dialogForm.approveStatus != 2"
        >保存
      </el-button>
      <el-button type="primary" @click="setWatermark" style="margin: 10px 0"
        >设置水印
      </el-button>
      <div style="display: inline-flex; width: 300px;margin-left:150px;">
        <el-input v-model="inputPages" placeholder="总页数" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputHeight" placeholder="单页高" style="margin-left: 10px;"></el-input>
        <el-input v-model="inputPosx" placeholder="偏移量" style="margin-left: 10px;"></el-input>
      </div>
    </div>
    <div
      ref="HTMLcarRentalContent"
      id="HTMLcarRentalContent"
      :key="printClass"
      :class="printClass"
    >
      <div class="carRentalContract1">
        <p style="text-align: center; line-height: 31px">
          <strong
            ><span style="font-family: 黑体; font-size: 24px"
              >汽车租赁合同</span
            ></strong
          >
        </p>
        <p style="text-align: center; line-height: 21px">
          <strong
            ><span style="font-family: 仿宋; font-size: 20px"
              >&nbsp;</span
            ></strong
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >合同编号：
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="serialNumber"
              >{{
                detailForm.serialNumber ? detailForm.serialNumber : ""
              }}</span
            >
          </span>
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >签订时间：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="signDate1"
              >{{ detailForm.signDate1 ? detailForm.signDate1 : "" }}</span
            ></span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >签约地点：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 400px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="signPlace"
              >{{ detailForm.signPlace || "青岛市市北区" }}</span
            ></span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >承租方（甲方）：<span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 345px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="partyA"
              >{{ detailForm.partyA ? detailForm.partyA : "" }}</span
            ></span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >出租方（乙方）：
            <span
              style="
                border-bottom: 1px solid rgb(44, 62, 80);
                outline: 0;
                text-indent: 5px;
                display: inline-block;
                min-width: 340px;
              "
              :contenteditable="
                dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
              "
              class="partyB"
              >{{ detailForm.partyB ? detailForm.partyB : "" }}</span
            ></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >根据《中华人民共和国民法典》及有关法律法规的规定，遵循平等、自愿和诚实信用的原则，甲方双方协商一致，就乙方向甲方提供车辆租赁服务等有关事宜，特订立以下合同条款：</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 黑体; font-size: 19px"
            >一、租赁车辆信息</span
          >
        </p>
        <table
          ref="carRentalTable"
          width="100%"
          :key="printClass"
          style="
            border-collapse: collapse;
            border-width: 1px;
            font-family: 楷体_GB2312;
            font-size: 19px;
            line-height: 31px;
          "
        >
          <thead style="display: table-header-group">
            <tr style="height: 68px" class="firstRow">
              <td
                width="42"
                valign="center"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >序号</span
                  >
                </p>
              </td>
              <td
                width="85"
                valign="center"
                colspan="2"
                style="
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-style: solid;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >品牌型号</span
                  >
                </p>
              </td>
              <td
                width="85"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >牌照号</span
                  >
                </p>
              </td>
              <td
                width="170"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >租赁</span
                  ><span style="font-family: 楷体_GB2312; font-size: 19px"
                    >起止日期</span
                  >
                </p>
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >(年月日</span
                  ><span style="font-family: 楷体_GB2312; font-size: 19px"
                    >-年月日</span
                  ><span style="font-family: 楷体_GB2312; font-size: 19px"
                    >）</span
                  >
                </p>
              </td>
              <td
                width="95"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >含税月租金</span
                  >
                </p>
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >（元）</span
                  >
                </p>
              </td>
              <td
                width="104"
                valign="top"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >&nbsp;</span
                  >
                </p>
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >含税总价</span
                  >
                </p>
                <p
                  style="
                    text-indent: 19px;
                    text-align: justify;
                    text-justify: inter-ideograph;
                    line-height: 31px;
                  "
                >
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >（元）</span
                  >
                </p>
              </td>
              <td
                width="38"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                  border-right-width: 0;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >税率</span
                  >
                </p>
              </td>
              <td
                width="48"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-width: 1px;
                  border-color: windowtext;
                "
              >
                <p style="text-align: center; line-height: 31px">
                  <span style="font-family: 楷体_GB2312; font-size: 19px"
                    >备注</span
                  >
                </p>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              style="page-break-inside: avoid"
              v-for="(item, index) in carRentaltableList"
              :key="item.id"
            >
              <td
                width="42"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column0 }}
              </td>
              <td
                width="85"
                valign="center"
                colspan="2"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column1 }}
              </td>
              <td
                v-if="index != carRentaltableList.length - 1"
                width="85"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column2 }}
              </td>
              <td
                v-else
                width="576"
                valign="top"
                colspan="7"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                v-html="item.column2"
              ></td>
              <td
                v-if="index != carRentaltableList.length - 1"
                width="170"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column3 }}
              </td>
              <td
                v-if="index != carRentaltableList.length - 1"
                width="95"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column4 }}
              </td>
              <td
                v-if="index != carRentaltableList.length - 1"
                width="104"
                valign="top"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column5 }}
              </td>
              <td
                v-if="index != carRentaltableList.length - 1"
                width="38"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 0;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column6 }}
              </td>
              <td
                v-if="index != carRentaltableList.length - 1"
                width="48"
                valign="center"
                style="
                  border-style: solid;
                  padding: 0px 7px;
                  border-left-width: 1px;
                  border-left-color: windowtext;
                  border-right-width: 1px;
                  border-right-color: windowtext;
                  border-top: none;
                  border-bottom-width: 1px;
                  border-bottom-color: windowtext;
                "
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
              >
                {{ item.column7 }}
              </td>
            </tr>
          </tbody>
        </table>
        <div
          style="display: flex"
          v-if="dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3"
        >
          <el-tooltip
            class="item"
            effect="dark"
            content="添加行"
            placement="top-start"
          >
            <i class="el-icon-plus" @click="addItem"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除行"
            placement="top-start"
          >
            <i class="el-icon-minus" @click="delItem"></i>
          </el-tooltip>
        </div>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 黑体; font-size: 19px"
            ><span style="font-family: 黑体">注：</span
            ><span style="font-family: 黑体">1、</span></span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >租金自合同签订，车辆交付之日起开始计算，结算按实际发生据实结算。</span
          >
        </p>
        <p style="text-indent: 75px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">2</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >、不含税单价固定不变，税金随着国家规定税率的调整而调整，最终税金金额以开具发票时的国家税率计算为准。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 黑体; font-size: 19px">二、付款方式</span>
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >付款方式：本合同租金在车辆使用结束后一次性付清，乙方同时开具符合甲方财务要求的增值税专用发票。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 黑体; font-size: 19px"
            >三、双方权利义务</span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >（一）乙方义务：</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >1、乙方提供的租赁车辆手续齐全，车况良好，可以合法使用，必须在交强险、第三者责任险及其他商业保险的有效期限内。发生事故后，乙方应积极会同甲方处理事故善后及保险理赔等事宜。。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >2、乙方负责车辆正常维修保养、车辆保险、车辆年检。乙方维修、保养车辆时，应提前报告甲方并征得同意，做到不影响甲方用车。如有影响，结算时按天数扣除租金。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >3、乙方为租赁车辆投保交强险、司机座位险、车损险（含玻璃险、自燃险）第三者责任险不低于100万、盗抢险、不计免赔保险。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >4、提供本市区域内故障救援服务。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >5、乙方交接租赁车辆时应如实提供车辆状况信息，应确保车辆配有随车的必要设施，如小型灭火器、安全锤等。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6、对甲方信息负有保密义务。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >7、如出现车辆维修、年审、接受定期检查或其他合理因素需要暂停运行时，乙方必须及时安排同等规格的车辆来代替，以确保每天车辆的正常运行为前提，否则甲方有权不支付乙方停止服务期间的租车费用，乙方应承担由此给甲方造成的经济损失。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >8、非经甲方书面许可，乙方不得向甲方提供第三方所有的车辆。</span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >（二）乙方权利：</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >1、乙方有权按合同约定收取租金，</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >2、在下述任何一种情况发生时，乙方有权终止合同，给乙方造成经济损失的甲方负责赔偿：</span
          >
        </p>
        <p style="text-indent: 19px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312">（</span
            ><span style="font-family: 楷体_GB2312"
              >1）甲方利用所租车辆从事违法犯罪活动。</span
            ></span
          >
        </p>
        <p style="text-indent: 19px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312">（</span
            ><span style="font-family: 楷体_GB2312"
              >2）甲方将所租赁车辆转让、转租、转包、出售、抵押、质押、投资、赠与等行为。</span
            ></span
          >
        </p>
        <p style="text-indent: 19px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            ><span style="font-family: 楷体_GB2312">（</span
            ><span style="font-family: 楷体_GB2312"
              >3）甲方提供虚假信息有可能给乙方带来损失的。</span
            ></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >3、甲方违法违规及有破坏性使用车辆（擅自拆卸、换车零部件）造成损失的按实际损失金额赔偿。</span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >（三）甲方权利：</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >1、有权使用车况良好，无安全隐患的车辆。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >2、甲方于租赁合同规定的租赁时段拥有所租车辆的使用权。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >3、对车辆承租前已有的损伤、质量问题及由此造成的损失，甲方不承担赔偿、维修义务。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >4、甲方因工作安排可要求解除合同，提前一个月通知乙方。</span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >（四）甲方义务：</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >1、按合同约定交纳租金及其他费用。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >2、所租车辆请到正规的加油站加油。</span
          >
        </p>
        <p style="line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >&nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family: 楷体_GB2312"
              >3、车辆租赁期间，驾驶人需持有效的中华人民共和国驾驶证且驾驶证上准驾车类别与租用车辆相符，如甲方登记的信息发生变化，应及时通知乙方。</span
            ></span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >4、甲方在车辆租赁期间发生本合同保险范围内事故，甲方及时通知乙方，乙方协助处理，办理保险公司理赔。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >5、由于甲方原因造成的保险公司拒赔及免赔的损失及相关费用由甲方承担。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6、甲方承担租赁期内所租车辆的燃油费用和过路过桥、停车费用。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >四、违约责任</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >1、甲乙任何一方如需提前解除本协议，均需提前一个月通知对方，双方互不承担违约责任。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">2、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >甲方如不按期支付租金或有违反本合同条款的行为</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">，</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >乙方有权随时可向甲方收回车辆，并要求</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">甲方</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >付清租金</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px">。</span>
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >3、乙方违反本合同约定，擅自提高收费标准的，甲方有权督促和要求乙方退还所收费用及利息，且乙方应按车辆租赁费总额的30
            &nbsp;&nbsp;&nbsp;%支付违约金。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >4、乙方未经甲方书面许可，向甲方出租第三方所有的车辆，甲方有权解除合同，乙方除应退还已收取的费用外，还应当支付车辆租赁费总额的30%的违约金,如甲方与第三方因车辆租赁引起的纠纷，由乙方全面负责。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >5、若乙方车辆问题造成甲方人身财产损害或其他经济损失，乙方承担全部赔偿责任，并承担甲方因追究乙方违约责任而产生的所有费用，包括但不限于通知公告费用、律师咨询代理费用、公证费用等。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >6、因不可抗力导致本合同无法履行的，双方互不承担违约责任。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >五、甲乙双方应共同遵守本合同，如有争议，应协商解决，协商不成应在甲方所在地人民法院提起诉讼。乙方承担为解决争议支付的全部费用，包括但不限于诉讼费、律师费等。</span
          >
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px"
            >六、本合同自租赁双方法定代表人签字并加盖公章后即生效，一式四份，甲方执二份，乙方执二份。</span
          >
        </p>
        <p style="text-indent: 0; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">&nbsp;</span>
        </p>
        <p style="text-indent: 37px; line-height: 31px">
          <span style="font-family: 黑体; font-size: 19px">七、</span
          ><span style="font-family: 楷体_GB2312; font-size: 19px"
            >本合同附件作为本合同的有效组成部分，与本合同具有同等法律效力。</span
          >
        </p>
        <p style="text-indent: 56px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">&nbsp;</span>
        </p>
        <p style="text-indent: 56px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">&nbsp;</span>
        </p>
        <p style="text-indent: 56px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">&nbsp;</span>
        </p>
        <p style="text-indent: 56px; line-height: 31px">
          <span style="font-family: 楷体_GB2312; font-size: 19px">&nbsp;</span>
        </p>
        <div style="display: flex; font-family: 楷体_GB2312; font-size: 19px">
          <div style="width: 380px">
            <p style="line-height: 31px">
              <span>甲方（盖章）：</span>
              <span
                class="partA_gongzhang"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                >{{ detailForm.partA_gongzhang }}</span
              >
            </p>
            <p style="line-height: 31px">
              <span style="font-family: 仿宋; font-size: 21px">&nbsp;</span>
            </p>
            <p style="line-height: 31px">
              <span
                ><span>授权代表人（签字）：</span
                ><span
                  class="partA_sign"
                  :contenteditable="
                    dialogForm.approveStatus != 2 &&
                    dialogForm.approveStatus != 3
                  "
                  >{{ detailForm.partA_sign }}</span
                ></span
              >
            </p>

            <p style="line-height: 31px">
              <span style="font-family: 仿宋; font-size: 21px">&nbsp;</span>
            </p>
            <p style="line-height: 31px">
              <span>日期：</span
              ><span
                class="partA_date"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                >{{ detailForm.partA_date }}</span
              >
            </p>
          </div>
          <div style="width: 380px">
            <p style="line-height: 31px">
              <span>乙方（盖章）：</span>
              <span
                class="partB_gongzhang"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                >{{ detailForm.partB_gongzhang }}</span
              >
            </p>
            <p style="line-height: 31px">
              <span>&nbsp;</span>
            </p>
            <p style="line-height: 31px">
              <span
                ><span>授权代表人（签字）：</span
                ><span
                  class="partB_sign"
                  :contenteditable="
                    dialogForm.approveStatus != 2 &&
                    dialogForm.approveStatus != 3
                  "
                  >{{ detailForm.partB_sign }}</span
                ></span
              >
            </p>

            <p style="line-height: 29px">
              <span>&nbsp;</span>
            </p>
            <p style="line-height: 31px">
              <span>日期：</span
              ><span
                class="partB_date"
                :contenteditable="
                  dialogForm.approveStatus != 2 && dialogForm.approveStatus != 3
                "
                >{{ detailForm.partB_date }}</span
              >
            </p>
          </div>
        </div>
        <p>
          <br />
        </p>
      </div>
    </div>
    <div class="printWrap" v-show="false">
      <div
        v-html="carRentalContent"
        class="mainHtml"
        id="printcarRentalContent"
      ></div>
    </div>
    <setWatermarkDialog
      ref="setWatermarking"
      @setWaterMarkFun="setWaterMarkFun"
    ></setWatermarkDialog>
  </div>
</template>

<script>
import {
  getServiceContractDetailService, //获取合同填充内容
} from "@/services/allContractServices";
import printJS from "print-js";
import { mixins } from "@/page/contract/template/mixin.js";
import setWatermarkDialog from "../commonCell/setWatermarkDialog.vue";
import { addPageNum, getTableData } from "./common.js";
import { addPageNumCustom } from "./common.js";

export default {
  name: "carRentalContract",
  components: {
    setWatermarkDialog,
  },
  mixins: [mixins],
  data() {
    return {
      carRentalContent: "", //富文本编辑器内容
      watermark: [""],
      saveflag: false,
      detailForm: { ...this.dialogForm },
      carRentaltableList: [
        {
          id: 1,
          column0: "1",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 2,
          column0: "2",
          column1: "",
          column2: "",
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
        {
          id: 2000,
          column0: "合计",
          column1: "",
          column2: `<p style="min-height: 52px;line-height: 31px">含税总价：<span style="text-decoration: underline"
                    >&nbsp;&nbsp;&nbsp;&nbsp;大写&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span >
                    元（不含税价：税率&nbsp;&nbsp;&nbsp;税金：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;）</p>`,
          column3: "",
          column4: "",
          column5: "",
          column6: "",
          column7: "",
        },
      ], //中间表格数据
      inputPages: "",
      inputHeight: 1010,
      inputPosx: 37,
    };
  },
  methods: {
    addItem() {
      let len = this.carRentaltableList.length - 2;
      let id = (this.carRentaltableList[len]?.id ?? 0) + 1;
      let item = {
        id: id,
        column0: "",
        column1: "",
        column2: "",
        column3: "",
        column4: "",
        column5: "",
        column6: "",
        column7: "",
      };
      this.carRentaltableList.splice(len + 1, 0, item);
    },
    delItem() {
      if (this.carRentaltableList.length > 1)
        this.carRentaltableList.splice(-2, 1);
    },
    /**
     * 初始化全部订单表格数据,配置表格列等数据
     *
     **/
    initOrderDetailTable() {
      this.getTableData();
    },
    //获取一条劳务合同信息
    getsubServiceContractDetail(id) {
      if (!id) return;
      let param = {};
      param.id = id;
      getServiceContractDetailService(param)
        .then((res) => {
          if (res.code == 10000000) {
            let data = {};
            if (res.data.subContractPrintVO) {
              data = res.data.subContractPrintVO;
              this.watermark = res.data.subContractPrintVO.watermark || [""];
              if (data.content) {
                this.saveflag = true;
                this.detailForm = JSON.parse(data.content);
                if (this.detailForm.carRentaltableList)
                  this.carRentaltableList = JSON.parse(
                    this.detailForm.carRentaltableList
                  );
                this.carRentaltableList.forEach((item, index) => {
                  if (index == this.carRentaltableList.length - 1) {
                    item.id = 2000;
                  } else {
                    item.id = index + 1;
                  }
                  return item;
                });
              } else {
                this.detailForm = { ...this.dialogForm };
                this.carRentaltableList = [
                  {
                    id: 1,
                    column0: "1",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 2,
                    column0: "2",
                    column1: "",
                    column2: "",
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                  {
                    id: 2000,
                    column0: "合计",
                    column1: "",
                    column2: `<p style="min-height: 52px;line-height: 31px">含税总价：<span style="text-decoration: underline"
                    >&nbsp;&nbsp;&nbsp;&nbsp;大写&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span >
                    元（不含税价：税率&nbsp;&nbsp;&nbsp;税金：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;）</p>`,
                    column3: "",
                    column4: "",
                    column5: "",
                    column6: "",
                    column7: "",
                  },
                ];
              }
            }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
          this.loading=false;
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
          this.loading=false;
        });
    },
    saveContractA() {
      if (this.detailForm.approveStatus == 2) {
        this.$alert("合同为待审核无法修改", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      // this.getValues();
      const table = this.$refs.carRentalTable;
      this.carRentaltableList = getTableData(table, this.carRentaltableList, 8);
      this.detailForm.carRentaltableList = JSON.stringify(
        this.carRentaltableList
      );
      // this.tableKey = Math.random();
      this.saveCommon('carRentalContract');
    },
    getValues() {
      // let Id = document.getElementById("HTMLcarRentalContent");
      let Id = document.getElementsByClassName(this.printClass)[0];
      this.detailForm.serialNumber =
        Id.getElementsByClassName("serialNumber")[0].innerText.trim();
      this.detailForm.partyA =
        Id.getElementsByClassName("partyA")[0].innerText.trim();
      this.detailForm.partyB =
        Id.getElementsByClassName("partyB")[0].innerText.trim();
      this.detailForm.signPlace =
        Id.getElementsByClassName("signPlace")[0].innerText.trim();
      Id.getElementsByClassName("signPlace")[0].innerHTML =
        this.detailForm.signPlace;
      this.detailForm.signDate1 =
        Id.getElementsByClassName("signDate1")[0].innerText.trim();
      Id.getElementsByClassName("signDate1")[0].innerHTML =
        this.detailForm.signDate1;

      this.detailForm.partA_gongzhang =
        Id.getElementsByClassName("partA_gongzhang")[0].innerText;
      Id.getElementsByClassName("partA_gongzhang")[0].innerHTML =
        this.detailForm.partA_gongzhang;
      this.detailForm.partA_sign =
        Id.getElementsByClassName("partA_sign")[0].innerText;
      Id.getElementsByClassName("partA_sign")[0].innerHTML =
        this.detailForm.partA_sign;
      this.detailForm.partA_date =
        Id.getElementsByClassName("partA_date")[0].innerText;
      Id.getElementsByClassName("partA_date")[0].innerHTML =
        this.detailForm.partA_date;

      this.detailForm.partB_gongzhang =
        Id.getElementsByClassName("partB_gongzhang")[0].innerText;
      Id.getElementsByClassName("partB_gongzhang")[0].innerHTML =
        this.detailForm.partB_gongzhang;
      this.detailForm.partB_sign =
        Id.getElementsByClassName("partB_sign")[0].innerText;
      Id.getElementsByClassName("partB_sign")[0].innerHTML =
        this.detailForm.partB_sign;
      this.detailForm.partB_date =
        Id.getElementsByClassName("partB_date")[0].innerText;
      Id.getElementsByClassName("partB_date")[0].innerHTML =
        this.detailForm.partB_date;
    },
    //打印当前合同
    PrintContractD() {
      if (this.dialogForm.approveStatus != 3) {
        this.$alert("合同尚未通过审核，无法打印", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      // let Id = document.getElementById("HTMLcarRentalContent");
      let Id = document.getElementsByClassName(this.printClass)[0];
      let elementsToRemove = Id.querySelectorAll(".page-num");
      elementsToRemove.forEach(function (element) {
        element.parentNode.removeChild(element);
      });
      //addPageNum(Id, 0, "carRentalContent");
      addPageNumCustom(Id, 0, "carRentalContent", this.inputPages, this.inputHeight, this.inputPosx);
      
      this.$set(
        this,
        "carRentalContent",
        this.$refs.HTMLcarRentalContent.innerHTML
      );
      this.$nextTick(() => {
        printJS({
          printable: "printcarRentalContent",
          type: "html",
          targetStyles: ["*"],
          ignoreElements: ["no-print", "bc", "gb"],
          scanStyles: false,
          style: `@page { size: auto; margin:10mm } p{line-height:31px;} .carRentalContract1 {background: url("data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Ctext x='50%25' y='50%25' font-size='14' fill-opacity='0.3' text-anchor='middle' dominant-baseline='middle' transform='rotate(-35, 100 100)'%3E${this.watermark.join(
            ";"
          )}%3C/text%3E%3C/svg%3E");
}`,
        });
      });
    },
    //设置水印
    setWatermark() {
      this.$refs.setWatermarking.showwaterMarkDialog(
        this.subServiceContractId,
        this.watermark
      );
    },
    setWaterMarkFun(val) {
      this.watermark = val;
      let param = {
        warterMark: this.watermark,
        version: "1.0",
        flag: 2,
      };
      this.$emit("savePrintInfo", param);
    },
  },
};
</script>

<style>
#HTMLcarRentalContent {
  /* position: relative; */
  width: 20cm;
  padding: 0 10px;
  margin-top: 58px;
  box-shadow: 0px 4px 12px 2px #bbb;
}
p {
  line-height: 31px;
}
.buttons {
  width: 22cm;
  height: 56px;
  position: fixed;
  top: 90px;
  background: white;
}
.printWrap {
  width: 21cm;
  margin: 30px auto;
  padding: 5mm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
}

.mainHtml {
  width: 21cm;
}
</style>
